import { AutoComplete } from "antd";
import React, { useRef, useState } from "react";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import styles from "./styles/autoSearchBox.module.scss";

const AutoSearchBox = ({
  onSearch,
  allowClear = true,
  options,
  fieldName,
  selectedValues,
  setSelectedValues,
  placeholder,
  onChange,
  onSelect,
  onBlur,
  disabled
}) => {
  const ref = useRef();
  const [value, setValue] = useState('')

  const handleSelect = (data) => {


    const arr = selectedValues?[...selectedValues]:[];
    arr.push(data);
    const uniq = [...new Set(arr)];
    setSelectedValues(uniq);
    setValue('')
    if (typeof onSelect === "function") {
      // onSelect();
    }
  };

  const handleChange = (val) => {
    if (typeof onChange === "function") {
      onChange();
    }
    setValue(val);
  }

  const handleBlur = () => {
    if (typeof onBlur === "function") {
      onBlur();
    }
    setValue("");
  }

  const handleRemove = (value) => {
    const arr = selectedValues.filter((item) => item !== value);
    setSelectedValues(arr);
    setValue('')
  };

  return (
    <>
      <div ref={ref}>
        <AutoComplete
          className="auto-search"
          onSearch={(val) => onSearch(fieldName, val)}
          onSelect={handleSelect}
          onChange={handleChange}
          allowClear={allowClear}
          options={options}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onBlur={handleBlur}
          getPopupContainer={() => ref.current}
        />
      </div>
      <div className={styles.chips_wrapper}>
        {selectedValues?.length > 0 &&
          selectedValues.map((item, index) => (
            <div className={styles.selected_value_chip} key={index} >
              <span className={styles.chip_name}>{item}</span>
              <CloseOutlined onClick={() => handleRemove(item)} />
            </div>
          ))}
      </div>
    </>
  );
};

export default AutoSearchBox;
